import en from './locale/en'
import fa from './locale/fa'

export default {
  en: en,

  fa: fa
}
